import type { ToolSearchProps, ToolSearchEmits } from "../index";

export const useComposable = (define: ToolSearchProps, emit: ToolSearchEmits) => {
    //* 获取I18n
    const i18n = useI18n();

    //* 响应式变量
    const refs = { keyword: ref<string>(define.modelValue) };

    //* 事件列表
    const methods = {
        init: (query?: string) => {
            refs.keyword.value = query || "";
            emit("update:modelValue", refs.keyword.value);
        },
    };

    //* 计算属性
    const computeds = {
        //* 主体动态属性
        mainStyles: computed(() => (define.width ? { width: `${define.width}px` } : {})),

        //* 输入框动态属性
        inputAttrs: computed(() => ({
            width: define.width || "100%",
            placeholder: define.placeholder || i18n.t("Layout.InputTypeSearch", { type: "Keyword" }),
        })),

        //* 输入框回调事件
        inputOns: computed(() => ({
            enter: () => emit("search"),
            input: () => {
                emit("update:modelValue", refs.keyword.value);
            },
        })),
    };

    return { refs, methods, computeds };
};
